// extracted by mini-css-extract-plugin
module.exports = {"section":"GoLMi","featureIcons":"_1kWpt","resetPaddingBottom":"_1cWsG"};